import { TextArea } from "./TextArea";
import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";

export function PostcodeInput(props: {
  value?: string;
  label?: string;
  onChange: (v: string) => void;
  sx?: SxProps<Theme>;
  inputLabelShrink?: boolean;
}) {
  const ukPostcodePattern = "^[A-Za-z]{1,2}[0-9][A-Za-z0-9]? *[0-9][A-Za-z]{2} *$";
  const ukPostcodeRegex = new RegExp(ukPostcodePattern);

  const validate = (value: string) => value.trim() !== "" && ukPostcodeRegex.test(value.trim().toUpperCase());

  return (
    <TextArea
      id="member-postcode"
      onChange={props.onChange}
      validateInput={validate}
      value={props.value}
      inputPattern={ukPostcodePattern}
      errorFeedbackText="Please enter a valid postcode"
      label={props.label || "Postcode"}
      sx={props.sx}
      inputLabelShrink={props.inputLabelShrink}
    />
  );
}
